module.exports = __webpack_public_path__ + "static/media/party.0262a1cd.svg";